import { useTenantDetailsContext } from '@/modules/tenant/TenantDetailsContext/TenantDetailsContext';

import { useCurrentUser } from '../../../authentication/hooks/useCurrentUser';

/**
 * @returns true if the current user is logged into Emoney
 */
export function useIsUserLoggedIntoEmoney() {
  const canConnect = useCanUserConnectToEmoney();
  const currentUser = useCurrentUser();
  const userCanInteractWithEmoney = currentUser?.loggedInToEMoney ?? false;
  return canConnect && userCanInteractWithEmoney;
}

/**
 * @returns true if eMoney is configured on the tenant.
 */
export function useCanUserConnectToEmoney() {
  const { integrationConfiguration } = useTenantDetailsContext();

  const userCanConnectToEmoney = Boolean(
    integrationConfiguration?.emoneyEnabled
  );

  return userCanConnectToEmoney;
}
